<template>
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-50 md-small-size-50 md-xsmall-size-100 md-size-50"
      >
        <pricing-card icon-color="icon-success">
          <!-- <h6 slot="category" class="category">我的寄存</h6> -->
          <md-card-media md-ratio="16:9" slot="icon">
            <img :src="images.buy_package">
          </md-card-media>
          <md-button slot="footer" class="md-success md-round"
            href="/my-packages"
            >我的寄存</md-button
          >
        </pricing-card>
      </div>
      
      <div
        class="md-layout-item md-medium-size-50 md-small-size-50 md-xsmall-size-100 md-size-50"
      >
        <pricing-card icon-color="icon-success">
          <!-- <h6 slot="category" class="category">寄存方案</h6> -->
          <md-card-media md-ratio="16:9" slot="icon">
            <img :src="images.packages">
          </md-card-media>
          <md-button slot="footer" class="md-success md-round"
            href="/packages"
            >優惠組合</md-button
          >
        </pricing-card>
      </div>

      <div
        class="md-layout-item md-medium-size-50 md-small-size-50 md-xsmall-size-100 md-size-50"
      >
        <pricing-card icon-color="icon-success">
          <!-- <h6 slot="category" class="category">原來是洋蔥門市</h6> -->
          <md-card-media md-ratio="16:9" slot="icon">
            <img :src="images.stores">
          </md-card-media>
          <md-button slot="footer" class="md-success md-round"
            href="/stores"
            >原來是洋蔥門市</md-button
          >
        </pricing-card>
      </div>

      <div
        class="md-layout-item md-medium-size-50 md-small-size-50 md-xsmall-size-100 md-size-50"
      >
        <pricing-card icon-color="icon-success">
          <!-- <h6 slot="category" class="category">個人資訊</h6> -->
          <md-card-media md-ratio="16:9" slot="icon">
            <img :src="images.person">
          </md-card-media>
          <md-button slot="footer" class="md-success md-round"
            href="/my-profile"
            >個人資訊</md-button
          >
        </pricing-card>
      </div>


    </div>
</template>
<script>
import { PricingCard } from "@/components";
export default {
  data() {
    return {
      images: {
        buy_package: `${process.env.VUE_APP_IMAGE_BASE_URL}/storage/my/buy_package.jpg?v=${Math.random()}`,
        packages: `${process.env.VUE_APP_IMAGE_BASE_URL}/storage/my/packages.jpg?v=${Math.random()}`,
        stores: `${process.env.VUE_APP_IMAGE_BASE_URL}/storage/my/stores.jpg?v=${Math.random()}`,
        person: `${process.env.VUE_APP_IMAGE_BASE_URL}/storage/my/person.jpg?v=${Math.random()}`,
      },
    };
  },  components: {
    PricingCard
  }
};
</script>
<style scoped>
.text-center {
  text-align: center;
}
</style>
